import styled from 'styled-components';
import { css } from 'src/styles/theme';
import { isBrandDS } from 'src/constants/main';
import { GlobalStyled } from '../shared/GlobalStyled';
import { SaveToYourProjectTemplate } from './SaveToYourProjectTemplate';

export const SaveToYourProject = styled(SaveToYourProjectTemplate)`
    ${GlobalStyled}
`;
